import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { DropdownSelectorProps, MetadataOptions } from './types';

function DropdownDatatypeSelector(props: DropdownSelectorProps) {
  const { onSelect, value } = props;


  const [selectedTemplate, setSelectedTemplate] = React.useState(value || '');

  const handleChange: any = (event: React.ChangeEvent<{ value: string }>) => {
    setSelectedTemplate(event.target.value as string);
    onSelect && onSelect(event.target.value);
  };

  const options = [
    {
      value: MetadataOptions.String,
      label: 'Κείμενο (αλφαριθμητικο)'
    },
    {
      value: MetadataOptions.Text,
      label: 'Κείμενο (πολύ μεγάλο)'
    },
    {
      value: MetadataOptions.Radio,
      label: 'Radio'
    },
    {
      value: MetadataOptions.Checkbox,
      label: 'Checkbox'
    },
    {
      value: MetadataOptions.Date,
      label: 'Ημερομηνία'
    },
    {
      value: MetadataOptions.Number,
      label: 'Νούμερο'
    },
    {
      value: MetadataOptions.File,
      label: 'Αρχείο'
    }
  ];

  return (
    <FormControl fullWidth>
      <InputLabel>Είδος Πεδίου</InputLabel>
      <Select
        MenuProps={{ disablePortal: true }}
        key={selectedTemplate}
        value={selectedTemplate}
        label='Είδος Πεδίου'
        onChange={handleChange}
      >
        {
          options.map((option) => {
            return <MenuItem key={option.label} value={option.value}
            >{option.label}</MenuItem>;
          })

        }
      </Select>
    </FormControl>
  );
}

export default DropdownDatatypeSelector;